import { SignoGecrosAfiliado } from '@interfaces/interface-bakend/entidades/signo-greco-afiliado.interface';

/**
 * Solo el label exacto "Con Cobertura" cuenta como cubierto.
 */
export function tieneCobertura(
    afiliado: Partial<SignoGecrosAfiliado> | null | undefined
): boolean {
    const estado = (afiliado as any)?.estado;
    return typeof estado === 'string' && estado.trim() === 'Con Cobertura';
}

/**
 * Subconjunto del payload de GECROS que se usa para decidir si nuestra DB
 * necesita actualizarse. Deja afuera los campos volátiles para que el sync
 * escriba solo cuando cambió algo que importa.
 */
export function buildComparablePayload(
    afiliado: Partial<SignoGecrosAfiliado> | null | undefined
): any {
    if (!afiliado) {
        return null;
    }

    return {
        numeroAfiliado: afiliado.numeroAfiliado,
        documento: afiliado.documento,
        nombreAfiliado: afiliado.nombreAfiliado,
        plan: afiliado.plan,
        convenio: afiliado.convenio,
        parentesco: afiliado.parentesco,
        estado: (afiliado as any)?.estado ?? null,
        coberturas: afiliado.coberturas,
    };
}

/**
 * Hash estable e insensible al orden de las claves de un valor comparable a
 * JSON. Sirve para comparar el payload de GECROS guardado contra el fresco y
 * no escribir a ciegas.
 */
export function fingerprint(obj: any): string {
    const normalize = (value: any): any => {
        if (Array.isArray(value)) {
            return value.map(normalize);
        }
        if (value && typeof value === 'object') {
            return Object.keys(value)
                .sort()
                .reduce((acc, key) => {
                    acc[key] = normalize(value[key]);
                    return acc;
                }, {} as any);
        }
        return value;
    };

    const serialized = JSON.stringify(normalize(obj));
    let hash = 0;
    for (let i = 0; i < serialized.length; i++) {
        hash = (hash * 31 + serialized.charCodeAt(i)) % 2147483647;
    }
    return String(hash);
}
